import { gql } from '@apollo/client'

export const USER_DELETED = gql`
  query UserDeleted($id: ID!) {
    userDeleted(id: $id)
  }
`
